import { GenericAccountParticipantResponse } from "../../api/services/client/models";
import { isEmpty, isNotEmpty } from "../../helpers/utils";
import { createGenericAccounts } from "../genericAccounts/createGenericAccount/siteCore/SiteCoreKeys";
import {
  ContactPreferences,
  EmailNotifications,
  LanguagePreference,
} from "./components/modelsAndSchemas/Models";

const EMPTY_LANGUAGE_PREFERENCE: LanguagePreference = {
  id: "",
  name: "",
  isSelected: false,
};

export const getSelectedLanguagePreference = (
  languagePreferences?: LanguagePreference[],
): LanguagePreference => {
  return (
    languagePreferences?.find(
      (langPref: LanguagePreference) => langPref.isSelected,
    ) ?? EMPTY_LANGUAGE_PREFERENCE
  );
};

/**
 * Returns the selected email address from the provided email notifications list.
 * If no email is marked as selected, returns the first email in the list.
 * If the list is empty or undefined, returns an empty string.
 */
export const getSelectedEmail = (emailList?: EmailNotifications[]) => {
  if (isEmpty(emailList)) return "";
  const selectedEmail =
    emailList?.find((email: EmailNotifications) => email.isSelected) ??
    emailList?.[0];
  return selectedEmail?.email ?? "";
};

export const getParticipantPreferredPhoneNumber = (
  data?: GenericAccountParticipantResponse,
) => {
  if (!data || isEmpty(data)) return "";
  if (isEmpty(data?.participantInformation?.preferredContactNumber)) return "";
  return `${data?.participantInformation?.preferredContactNumberISOCode} ${data?.participantInformation?.preferredContactNumber}`;
};

export const getSelectedContactPreferences = (
  contactPreferences?: ContactPreferences,
  getContactPreferencesLabel = (key: string) => key,
) => {
  if (isEmpty(contactPreferences)) return [];
  const smsNotificationsLabel = contactPreferences?.smsNotifications
    ? getContactPreferencesLabel(createGenericAccounts.textSMS)
    : "";
  const emailNotificationsLabel = contactPreferences?.emailNotifications
    ? getContactPreferencesLabel(createGenericAccounts.email)
    : "";
  if (isEmpty(smsNotificationsLabel) && isEmpty(emailNotificationsLabel)) {
    return [];
  }

  const contactPreferencesLabels = [
    smsNotificationsLabel,
    emailNotificationsLabel,
  ].filter((value: string) => isNotEmpty(value));

  return contactPreferencesLabels.map((value: string) => ({
    value: value,
    label: value,
  }));
};
